import React, { useEffect, useCallback, useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";

import Home from "../pages/Home";
import Error404 from "../pages/404";

const routes: {
  path: string;
  exact?: boolean;
  RouteComponent: React.FunctionComponent;
  noHeader?: boolean;
}[] = [
  {
    path: "/",
    exact: true,
    RouteComponent: Home,
  },
  {
    // catch all route
    path: "*",
    RouteComponent: Error404,
  },
];

export default routes;

export const useRouteControls = ({
  onRouteChange,
}: {
  onRouteChange?: (...args: any) => any;
} = {}) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (onRouteChange) onRouteChange(location);
  }, [location, onRouteChange]);

  const setHash = useCallback(
    (hash: string) =>
      history.push(location.pathname + (hash ? `#${hash}` : "")),
    [history, location.pathname],
  );

  const goTo = useCallback(
    (route: string) => {
      history.push(route);
      window.scrollTo(0, 0);
    },
    [history],
  );

  return useMemo(
    () => ({
      setHash,
      removeHash: () => setHash(""),

      goTo: {
        home: () => goTo("/"),
      },
    }),
    [goTo, setHash],
  );
};
